/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum PaymentMethod {
  CREDIT_CARD = 'credit_card',
  ACH = 'ach',
  AGO_PAYMENT = 'ago_payment',
  WH_OFFSET = 'wh_offset',
  FINANCE_JV = 'finance_jv',
  TRANSMITTAL = 'transmittal',
}
